$(document).ready(function(){
var offset = 70;
  $("a.create-walk-button").click(function () {
            $("html, body").animate({ scrollTop: $("div#create-walk").offset().top - offset }, 1000);
  });
  if (window.location.href.indexOf('#create-walk') > -1) {
        $("html, body").animate({ scrollTop: $("div#create-walk").offset().top - offset }, 100);
      }
});

$(document).ready(function(){
var offset = 70;
  $("a.create-walk-button-custom").click(function () {
            $("html, body").animate({ scrollTop: $(".create-your-walk-kit").offset().top - offset }, 1000);
  });
  if (window.location.href.indexOf('.create-your-walk-kit') > -1) {
        $("html, body").animate({ scrollTop: $(".create-your-walk-kit").offset().top - offset }, 100);
      }
});